import { Component, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  query,
  animateChild
} from '@angular/animations';
import { UserService } from '../../../../shared/services/user.service';
import { User } from '../../../../shared/models/User';
import { AuthService } from '../../../../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  animations: [
    trigger('slide', [
      transition(':enter', [
        style({ opacity: '0', height: '0' }),
        animate('.2s ease-out', style({ opacity: '1', height: '*' })),
      ]),
      transition(':leave', [
        style({ opacity: '1', height: '*' }),
        animate('.2s ease-out', style({ opacity: '0', height: '0' })),
      ]),
    ]),
  ],
})
export class UserComponent {
  @Input() isOpen: boolean = false;

  user: User;
  isLoggedIn: boolean = false;

  constructor(private userService: UserService,
              private auth: AuthService,
              private router: Router) {

    userService.currentUser.subscribe(user => {
      if (!user) { return; }
      this.user = user;
    });

    auth.loggedIn.subscribe(value => {
      this.isLoggedIn = value;

      if (this.isLoggedIn) {
        this.userService.getThisUser();
      }
    });
  }

  toggle() {
    this.isOpen = !this.isOpen || false;
    if (!this.isLoggedIn) {
      this.router.navigate(['/login']);
    }
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/header/components/user/user.component.ts